"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCUMENT_TO_APPROVE_URL_PARAM = exports.PERSON_TYPES_ORDER = exports.GENDERS = exports.PERSON_TYPES = exports.REPORT_STATUSES = void 0;
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./admin"), exports);
tslib_1.__exportStar(require("./answers"), exports);
tslib_1.__exportStar(require("./document"), exports);
tslib_1.__exportStar(require("./person"), exports);
tslib_1.__exportStar(require("./printPdf"), exports);
var REPORT_STATUSES;
(function (REPORT_STATUSES) {
    REPORT_STATUSES["inProgress"] = "inProgress";
    REPORT_STATUSES["paymentReceived"] = "paymentReceived";
    REPORT_STATUSES["waitingForDocument"] = "waitingForDocument";
    REPORT_STATUSES["waitingForApproval"] = "waitingForApproval";
    REPORT_STATUSES["waitingForSignatures"] = "waitingForSignatures";
    REPORT_STATUSES["completedAndSent"] = "completedAndSent";
    REPORT_STATUSES["closed"] = "closed";
})(REPORT_STATUSES = exports.REPORT_STATUSES || (exports.REPORT_STATUSES = {}));
var PERSON_TYPES;
(function (PERSON_TYPES) {
    PERSON_TYPES["self"] = "self";
    PERSON_TYPES["partner"] = "partner";
    PERSON_TYPES["child"] = "child";
})(PERSON_TYPES = exports.PERSON_TYPES || (exports.PERSON_TYPES = {}));
var GENDERS;
(function (GENDERS) {
    GENDERS["male"] = "m";
    GENDERS["female"] = "f";
})(GENDERS = exports.GENDERS || (exports.GENDERS = {}));
exports.PERSON_TYPES_ORDER = [PERSON_TYPES.self, PERSON_TYPES.partner, PERSON_TYPES.child];
exports.DOCUMENT_TO_APPROVE_URL_PARAM = 'document';
//# sourceMappingURL=index.js.map